import { observable, action } from 'mobx'

class UnlockVipSlice {
    @observable isChatLocked = false;
    @observable purchaseSuccess = false;
    @observable isLoading = false;

    @action
    toggleChatLocked(value) {
        this.isChatLocked = value !== undefined ? value : !this.isChatLocked;
    }

    @action
    unlockChatWithCredits() {
        this.purchaseSuccess = true;
    }
}

export default UnlockVipSlice;
